import { Box, Grid, Typography, TextField } from "@mui/material";
import styles from "../../Candidates/Candidate.module.css";
import RootComponents from "../../../components/common/RootComponents";
import { customTextColor } from "../../../utils/const";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { PiMailboxLight } from "react-icons/pi";
import { CiMobile3, CiTextAlignCenter } from "react-icons/ci";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosArrowRoundForward } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  checkCandidateExist,
  createCandidateProfile,
  createExistCandidateProfile,
  getAllCandidate,
  updateExistCandidateProfile,
} from "../../../redux/candidate/candidateSlice";
import { getProfile } from "../../../redux/profile/profileSlice";
import { addOfficialReference } from "../../../redux/InternalStatic/internalCandidateStatic";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const AddConsultantSubmit = ({ setMenuName, setMenuId }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { formik1 } = location?.state || {};
  const { formik2 } = location?.state || {};
  const { formik3 } = location?.state || {};
  const { row } = location?.state || {};
  const { prevData2 } = location.state || {};
  const { prevData3 } = location.state || {};
  const { prevData } = location.state || {};
  const { prevData1 } = location.state || {};
  const { selectedFileName } = location?.state || {};
  const profile = useSelector((state) => state.profile.data);

  const searchData = useSelector((state) => state.candidate.searchData);
  const candidateStatus = useSelector((state) => state.candidate.status);
  const officialReferenceData = useSelector(
    (state) => state.internalCandidateStatic.officialReferenceData
  );
  const formik = useFormik({
    initialValues: {
      referrer_company_name:
        row?.referrer_company_name ||
        officialReferenceData?.referrer_company_name ||
        null,
      referrer_mobile_no:
        row?.referrer_mobile_no ||
        officialReferenceData?.referrer_mobile_no ||
        null,
      referrer_email:
        row?.referrer_email || officialReferenceData?.referrer_email || null,
      referrer_manager_name:
        row?.referrer_manager_name ||
        officialReferenceData?.referrer_manager_name ||
        null,
      referrer_manager_name2:
        row?.referrer_manager_name2 ||
        officialReferenceData?.referrer_manager_name2 ||
        null,
      referrer_company_name2:
        row?.referrer_company_name2 ||
        officialReferenceData?.referrer_company_name2 ||
        null,
      referrer_mobile_no2:
        row?.referrer_mobile_no2 ||
        officialReferenceData?.referrer_mobile_no2 ||
        null,
      referrer_email2:
        row?.referrer_email2 || officialReferenceData?.referrer_email2 || null,
    },
    onSubmit: (values) => {},
  });

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);

  useEffect(() => {
    let mobile_no = formik1?.mobile_no?.replace(/[^0-9]/g, "");
    let email = formik1?.email;

    dispatch(checkCandidateExist({ email, mobile_no }));
  }, [formik1]);

  let userData = {
    email: formik1?.email,
    mobile_no: parseInt(formik1?.mobile_no?.replace(/[^0-9]/g, ""), 10),
    alternative_mobile_no: formik1?.alternative_mobile_no?.replace(
      /[^0-9]/g,
      ""
    ),
    full_name: formik1?.full_name,
    gender: "Male",
    current_job_title: formik1?.current_job_title,
    total_experience: Number(formik1?.total_experience),
    current_location: formik1?.current_location,
    prefer_location: formik1?.prefer_location,
    work_authorization: `${formik1?.work_authorization}`,
    prefer_tax_team: formik1?.prefer_tax_team,
    prefer_tax_team: "working_in_all",
    p_tax_team: formik1?.prefer_tax_team,
    work_preference: formik2?.work_preference,
    previous_experience: JSON.stringify(formik3),
    rate: formik2?.rate,
    rate: Number(formik2?.rate),
    linkedin_profile_url: formik1?.linkedin_profile_url,
    resume: formik1?.resume,
    current_company: formik2?.current_company,
    passing_year: formik2?.passing_year,
    passing_year: `${formik2?.passing_year}`,
    highest_qualification: formik2?.highest_qualification,
    university: formik2?.university,
    skills: formik2?.skills,
    secondary_skills: JSON.stringify(formik2?.secondary_skills),
    referrer_company_name: formik?.values?.referrer_company_name,
    referrer_mobile_no: formik?.values?.referrer_mobile_no,
    referrer_email: formik?.values?.referrer_email,
    referrer_company_name2: formik?.values?.referrer_company_name2,
    referrer_mobile_no2: formik?.values?.referrer_mobile_no2,
    referrer_email2: formik?.values?.referrer_email2,
    referrer_manager_name: formik?.values?.referrer_manager_name,
    referrer_manager_name2: formik?.values?.referrer_manager_name2,
    role: "CANDIDATE",
    recruiter_user_id: profile?.profile?.user_id,
    candidate: searchData?.candidate_id,
  };

  const handleOnSubmitTracker = () => {
    dispatch(addOfficialReference(formik.values));
    setMenuName("Profile Review");
    setMenuId(3);
  };

  // const handleOnSubmitTracker = () => {
  //   let id = row?.id;
  //   if (row !== undefined) {
  //     dispatch(updateExistCandidateProfile({ userData, id }));
  //   } else {
  //     if (searchData?.exist) {
  //       dispatch(createExistCandidateProfile(userData));
  //     } else {
  //       dispatch(createCandidateProfile(userData));
  //     }
  //   }
  // };

  useEffect(() => {
    if (
      candidateStatus === "create_candidate_profile" ||
      candidateStatus === "create_candidate_exist_profile"
    ) {
      dispatch(getAllCandidate());
      navigate("/candidate-listing");
    }
  }, [candidateStatus]);

  useEffect(() => {
    if (profile !== null) {
      formik.setFieldValue("recruiter_user_id", profile?.profile?.user_id);
    }
  }, [profile]);

  return (
    // <RootComponents>
    <>
      <Box className={styles.candidate_structure} sx={{ marginTop: "0" }}>
        <Typography
          className={styles.add_candidate_heading}
          sx={{ margin: "0 !important", padding: "0 15px !important" }}
        >
          <b> Official Reference</b>
        </Typography>

        <Box className={styles.employer_details}>
          <Typography sx={{ color: customTextColor }}>
            1st Refference (Optional)
          </Typography>

          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiBuildingOfficeLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Company Name"
                variant="standard"
                sx={fieldStyle}
                name="referrer_company_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_company_name}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Manager’s Name"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_manager_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_manager_name}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiMailboxLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Work Phone No"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_mobile_no"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_mobile_no}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Work E-Mail ID"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_email}
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={styles.employer_details}>
          <Typography sx={{ color: customTextColor }}>
            2nd Refference (Optional)
          </Typography>

          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiBuildingOfficeLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Company Name"
                variant="standard"
                sx={fieldStyle}
                name="referrer_company_name2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_company_name2}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Manager’s Name"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_manager_name2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_manager_name2}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Phone No"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_mobile_no2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_mobile_no2}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="E-Mail ID"
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_email2"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_email2}
              />
            </Grid>
          </Grid>
        </Box>

        <Box className={styles.add_consultant_btns}>
          <button
            onClick={() => {
              // navigate("/candidate-add-experience", {
              //   state: {
              //     prevData: formik1 || prevData,
              //     prevData1: formik2 || prevData1,
              //     selectedFileName: selectedFileName,
              //     prevData2: formik3 || prevData2,
              //     prevData3: formik?.values || prevData3,
              //   },
              // })
              setMenuName("Skill and Experience");
              setMenuId(1);
            }}
            style={{
              border: "1.5px solid #4285f4",
              marginRight: "10px",
              padding: "6px 10px ",
              color: "#fff",
            }}
            disabled={candidateStatus === "loading"}
          >
            <IoIosArrowRoundBack style={{ fontSize: "25px", color: "#fff" }} />
          </button>
          <button
            onClick={handleOnSubmitTracker}
            style={
              candidateStatus === "loading"
                ? {
                    padding: "7px 40px",
                  }
                : {}
            }
            disabled={candidateStatus === "loading"}
          >
            {candidateStatus === "loading" ? "Loading..." : "Save Details"}{" "}
            <IoIosArrowRoundForward
              style={{ fontSize: "25px", marginLeft: "5px" }}
            />
          </button>
        </Box>

        {/* <Box className={styles.next_btns}>
          <Box className={styles.add_back_btns}>
            <button
              onClick={() => navigate(-1)}
              style={{
                border: "1.5px solid #4285f4",
                marginRight: "10px",
                padding: "4.5px 10px ",
              }}
            >
              <IoIosArrowRoundBack
                style={{ fontSize: "25px", color: "#4285f4" }}
              />
            </button>
          </Box>
          <button
            // onClick={handleClickOpen}
            onClick={handleOnSubmitTracker}
            style={{ backgroundColor: "#3856a6 ", padding: "7px 10px " }}
          >
            Save Details
          </button>
        </Box> */}
      </Box>
      {/* <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        maxWidth="md"
        aria-labelledby="responsive-dialog-title"
        fullWidth={true}
      >
        <Box>
          <DialogTitle
            id="responsive-dialog-title">
            <b>Happy to Inform You – No Duplicate Found</b>
            <span style={{ display: 'block', }}>
              <b> Get 1000+ Credit Before Someone by Publishing Same Profile</b>
            </span>
            <span style={{ display: 'block', }}>
              <b>  Profile should be verified by respective candidate</b>
            </span>
          </DialogTitle>
          <DialogContent>


            <Box className={styles.company_list_structure}>
              <Typography className={styles.company_list_text}>
                Candidate Information & resume is correct?
              </Typography>
              <span>
                <Box className={styles.add_btn}>
                  <button
                    style={{
                      backgroundColor: '#2DD864',

                    }}
                  >
                    Yes
                  </button>
                  <button
                    style={{
                      marginLeft: '5px',
                      backgroundColor: '#F01010',

                    }}
                  >
                    No
                  </button>
                </Box>
              </span>
            </Box>

            <Box className={styles.company_list_structure}>
              <Typography className={styles.company_list_text}>
                Will we notify you to change the candidate status?
              </Typography>
              <span>
                <Box className={styles.add_btn}>
                  <button
                    style={{
                      backgroundColor: '#2DD864',
                    }}>
                    Yes
                  </button>
                  <button
                    style={{
                      marginLeft: '5px',
                      backgroundColor: '#F01010',
                    }}>
                    No
                  </button>
                </Box>
              </span>
            </Box>

            <Box className={styles.company_list_structure}>
              <Typography className={styles.company_list_text}>
                Will we notify you when received same profile from others?
              </Typography>
              <span>
                <Box className={styles.add_btn}>
                  <button
                    style={{
                      backgroundColor: '#2DD864',
                    }}
                  >
                    Yes
                  </button>
                  <button
                    style={{
                      marginLeft: '5px',
                      backgroundColor: '#F01010',
                    }}
                  >
                    No
                  </button>
                </Box>
              </span>
            </Box>

            <Box className={styles.company_list_structure}>
              <Typography className={styles.company_list_text}>
                Will we send your matching to this candidate?
              </Typography>
              <span>
                <Box className={styles.add_btn}>
                  <button
                    style={{
                      backgroundColor: '#2DD864',
                    }}
                  >
                    Yes
                  </button>
                  <button
                    style={{
                      marginLeft: '5px',
                      backgroundColor: '#F01010',
                    }}
                  >
                    No
                  </button>
                </Box>
              </span>
            </Box>


          </DialogContent>
          <Box>
            <Box className={styles.adding_internal_btns}>
              <button sx={{ backgroundColor: "#97B6F1 " }}>Internal</button>
              <button sx={{ backgroundColor: "#2d73b5 " }}>Publish</button>
            </Box>
          </Box>
        </Box>
      </Dialog> */}
      {/* <Dialog
        fullScreen={fullScreen}
        open={openManage}
        onClose={handleManageClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogContent>
          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Employer Name"
                variant="standard"
                sx={fieldStyle}
                name="referrer_manager_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_manager_name}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="E-Mail ID "
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_email}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Phone No "
                variant="standard"
                type="text"
                sx={fieldStyle}
                name="referrer_mobile_no"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_mobile_no}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "10px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiBuildingOfficeLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Company Name"
                variant="standard"
                sx={fieldStyle}
                name="referrer_company_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_company_name}
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Box className={styles.update_btn}>
              <button onClick={handleClose}>Confirm</button>
            </Box>
          </DialogActions>
        </DialogContent>
      </Dialog> */}
    </>
    // </RootComponents>
  );
};

export default AddConsultantSubmit;
